import { ezErrorDisplay, ezErrorDisplayOff } from 'lib/error-helpers';
import { parseErrorMsg } from 'lib/validation-helpers';
import Cookies from 'js-cookie';

export function socialSessionLoading(target:HTMLElement, ogText = '') {
  const textTarget = target.querySelector('[data-social-session-buttons-target*="text"]') || null;

  if (ogText) {
    textTarget.innerHTML = ogText;
  } else {
    textTarget.innerHTML = target.dataset.loadingText;
  }
}

export function socialSessionError(value:boolean, target:HTMLElement) {
  if (value) {
    ezErrorDisplay(target, parseErrorMsg(target, 'permissions_error') as string);
  } else {
    ezErrorDisplayOff(target);
  }
}

export function socialSessionRedirect(element:HTMLElement, csrfToken:string, action:string) {
  const f = document.createElement('form');

  f.style.display = 'none';
  element.appendChild(f);

  const csrfField = document.createElement('input');

  csrfField.value = csrfToken;
  csrfField.name = 'authenticity_token';

  f.appendChild(csrfField);
  f.method = 'POST';
  f.action = action;
  f.submit();
}

export function socialSessionFromFollow() {
  const primerCookie = Cookies.get('primer_for_post_login_cookie');

  if (primerCookie && primerCookie.includes('follow_after_login')) {
    return true;
  }
  return false;
}

export function fromSignup() {
  return Cookies.get('social_oauth_type') === 'registration';
}

export function showSignupSurvey(req) {
  return req.headers['content-type'] === 'text/javascript; charset=utf-8';
}

export function removeSocialOauthCookie() {
  Cookies.remove('social_oauth_type');
}
